import Vue from 'vue'
import Router from 'vue-router'
//import Home from './views/Home.vue'
import Rapportino from './views/nuovoRapportino.vue'
import FoglioOre from './views/nuovoFoglioOre.vue'
import Login from './views/Login.vue'
import FoglioOreCmp from './views/FoglioOre.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: Login
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/nuovoRapportino',
      name: 'nuovoRapportino',
      component: Rapportino
    }, {
      path: '/login',
      name: 'login',
      component: Login
    }, {
      path: '/foglioOreOld',
      name: 'foglioOreOld',
      component: FoglioOre
    },
    {
      path:'/foglioOre',
      name:'FoglioOre',
      component:FoglioOreCmp
    }
  ]
})